import React from 'react';

export const ShutterLeftPostLeftFoldRightFoldPostRight = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 201.89 59.29"
      width="205"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h190.93v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.39V.6a.7.7 0 01.77-.6h190.93c.43 0 .77.26.77.59v50.8c0 .32-.34.58-.77.58H5.49a.68.68 0 01-.77-.58zm190.93-50.2H6.26V50.8h189.39z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h190.93v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.39V.6a.7.7 0 01.77-.6h190.93c.43 0 .77.26.77.59v50.8c0 .32-.34.58-.77.58H5.49a.68.68 0 01-.77-.58zm190.93-50.2H6.26V50.8h189.39z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h182.12v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.62c-.42 0-.77-.26-.76-.58V4c0-.32.34-.58.77-.58H192c.43 0 .77.26.77.58v44c0 .32-.34.58-.77.58H9.89zM191.25 4.54H10.67v42.91h180.58z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 51.94h200.46a.57.57 0 00.69-.42.58.58 0 00-.43-.69.57.57 0 00-.26 0H.73a.67.67 0 00-.73.56c0 .3.33.55.73.55z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M34.54 8.27L6.75 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338"
            d="M6.26 1.53L35 7.76v51.53l-28.78-7zM34 8.8L7.24 3v48.23L34 57.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M31.54 12.93L9.49 8.08v3.57l22.05 4.89v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M9.24 7.72l22.55 5V17L9.24 12zm22 5.49L9.75 8.47v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M31.54 16.54L9.49 11.65v3.57l22.05 4.93v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M9.24 11.28l22.55 5v4.27L9.24 15.49zm22 5.54L9.75 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M31.54 20.15L9.49 15.22v3.57l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M9.24 14.85l22.55 5v4.27L9.24 19.06zm22 5.58L9.75 15.61v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M31.54 23.79L9.49 18.81v3.57l22.05 5.02v-3.61z"
          />
          <path
            data-name="Path 2342"
            d="M9.24 18.44l22.55 5.09v4.27L9.24 22.65zm22 5.63L9.75 19.2v2.92L31.27 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M31.54 27.4L9.49 22.38v3.57l22.05 5.06V27.4z"
          />
          <path
            data-name="Path 2343"
            d="M9.24 22l22.55 5.13v4.27L9.24 26.22zm22 5.67l-21.49-4.9v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M31.54 31.01L9.49 25.95v3.56l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M9.24 25.57l22.55 5.18V35L9.24 29.79zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M31.54 34.62L9.49 29.51v3.57l22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M9.24 29.14l22.55 5.23v4.26L9.24 33.35zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M31.54 38.23L9.49 33.08v3.57l22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M9.24 32.71L31.79 38v4.26L9.24 36.92zm22 5.8l-21.52-5v2.92l21.52 5.07z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M31.54 41.85l-22.05-5.2v3.56l22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M9.24 36.28l22.55 5.3v4.27L9.24 40.48zm22 5.83L9.75 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M31.54 45.48L9.49 40.24v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M9.24 39.86l22.55 5.36v4.27L9.24 44.07zm22 5.89L9.75 40.62v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M31.54 49.1L9.49 43.81v3.57l22.05 5.33V49.1z"
          />
          <path
            data-name="Path 2349"
            d="M9.24 43.42l22.55 5.41v4.27L9.24 47.64zm22 5.94L9.75 44.19v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M69.06 8.27L41.27 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-2"
            d="M40.78 1.53l28.78 6.23v51.53l-28.78-7zM68.56 8.8L41.76 3v48.23l26.8 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M66.06 12.93L44.02 8.08v3.57l22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M43.76 7.72l22.55 5V17l-22.55-5zm22 5.49L44.27 8.47v2.92l21.53 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M66.06 16.54l-22.04-4.89v3.57l22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M43.76 11.28l22.55 5v4.27l-22.55-5.06zm22 5.54L44.27 12v3l21.53 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M66.06 20.15l-22.04-4.93v3.57l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M43.76 14.85l22.55 5v4.27L43.76 19zm22 5.58l-21.49-4.82v2.92l21.53 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M66.06 23.79l-22.04-4.98v3.57l22.04 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-2"
            d="M43.76 18.44l22.55 5.09v4.27l-22.55-5.15zm22 5.63L44.27 19.2v2.92L65.8 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M66.06 27.4l-22.04-5.02v3.57l22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-2"
            d="M43.76 22l22.55 5.13v4.27l-22.55-5.18zm22 5.67l-21.49-4.9v2.92l21.53 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M66.06 31.01l-22.04-5.06v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M43.76 25.57l22.55 5.18V35l-22.55-5.21zm22 5.72l-21.53-5v2.92l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M66.06 34.62l-22.04-5.11v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M43.76 29.14l22.55 5.23v4.26l-22.55-5.28zm22 5.76l-21.53-5v2.93l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M66.06 38.23l-22.04-5.15v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M43.76 32.71L66.31 38v4.26l-22.55-5.34zm22 5.8l-21.53-5v2.92l21.57 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M66.06 41.85l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M43.76 36.28l22.55 5.3v4.27l-22.55-5.37zm22 5.83L44.27 37v3l21.53 5.07z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M66.06 45.48l-22.04-5.24v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M43.76 39.86l22.55 5.36v4.27l-22.55-5.42zm22 5.89l-21.49-5.13v2.92l21.53 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M66.06 49.1l-22.04-5.29v3.57l22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-2"
            d="M43.76 43.42l22.55 5.41v4.27l-22.55-5.46zm22 5.94l-21.49-5.17v2.92l21.53 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M55.59 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M69.06 8.27l27.79-6.03v49.49l-27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-3"
            d="M97.34 52.24l-28.78 7V7.76l28.78-6.23zm-27.78 5.54l26.8-6.55V3l-26.8 5.8z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M72.06 12.93L94.1 8.08v3.57l-22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M94.36 11.93l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.53-4.77V8.47l-21.57 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M72.06 16.54l22.04-4.89v3.57l-22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M94.36 15.49l-22.55 5.06v-4.27l22.55-5zm-22 4.28L93.85 15v-3l-21.53 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M72.06 20.15l22.04-4.93v3.57l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M94.36 19.06l-22.55 5.1v-4.27l22.55-5zm-22 4.33l21.53-4.86v-2.92l-21.57 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M72.06 23.79l22.04-4.98v3.57L72.06 27.4v-3.61z"
          />
          <path
            data-name="Path 2342-3"
            d="M94.36 22.65L71.81 27.8v-4.27l22.55-5.09zM72.32 27l21.53-4.9v-2.9l-21.53 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M72.06 27.4l22.04-5.02v3.57l-22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-3"
            d="M94.36 26.22l-22.55 5.19v-4.27L94.36 22zm-22 4.41l21.53-4.94v-2.92l-21.57 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M72.06 31.01l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M94.36 29.79L71.81 35v-4.25l22.55-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M72.06 34.62l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M94.36 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M72.06 38.23l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M94.36 36.92l-22.55 5.32V38l22.55-5.3zm-22 4.54l21.53-5.07v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M72.06 41.85l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M94.36 40.48l-22.55 5.37v-4.27l22.55-5.3zm-22 4.59L93.85 40v-3l-21.53 5.1z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M72.06 45.48l22.04-5.24v3.57L72.06 49.1v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M94.36 44.07l-22.55 5.42v-4.27l22.55-5.36zm-22 4.64l21.53-5.17v-2.92l-21.57 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M72.06 49.1l22.04-5.29v3.57l-22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-3"
            d="M94.36 47.64L71.81 53.1v-4.27l22.55-5.41zm-22 4.68l21.53-5.21v-2.92l-21.57 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M82.53 10.63l1.44-.32v39.52l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-4">
        <g data-name="Group 498-4">
          <path
            data-name="Rectangle 182-4"
            fill="#233762"
            d="M167.11 8.27l27.79-6.03v49.49l-27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-4"
            d="M195.39 52.24l-28.78 7V7.76l28.78-6.23zm-27.77 5.54l26.79-6.55V3l-26.79 5.8z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-4">
          <path
            data-name="Rectangle 183-4"
            fill="#233762"
            d="M170.12 12.93l22.04-4.85v3.57l-22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-4"
            d="M192.41 11.93l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.52-4.77V8.47l-21.55 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-4">
          <path
            data-name="Rectangle 184-4"
            fill="#233762"
            d="M170.12 16.54l22.04-4.89v3.57l-22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-4"
            d="M192.41 15.49l-22.55 5.06v-4.27l22.55-5zm-22 4.28L191.9 15v-3l-21.52 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-4">
          <path
            data-name="Rectangle 185-4"
            fill="#233762"
            d="M170.12 20.15l22.04-4.93v3.57l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-4"
            d="M192.41 19.06l-22.55 5.1v-4.27l22.55-5zm-22 4.33l21.52-4.86v-2.92l-21.52 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-4">
          <path
            data-name="Rectangle 186-4"
            fill="#233762"
            d="M170.12 23.79l22.04-4.98v3.57l-22.04 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-4"
            d="M192.41 22.65l-22.55 5.15v-4.27l22.55-5.09zm-22 4.37l21.52-4.9V19.2l-21.52 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-4">
          <path
            data-name="Rectangle 187-4"
            fill="#233762"
            d="M170.12 27.4l22.04-5.02v3.57l-22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-4"
            d="M192.41 26.22l-22.55 5.19v-4.27L192.41 22zm-22 4.41l21.52-4.94v-2.92l-21.52 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-4">
          <path
            data-name="Rectangle 188-4"
            fill="#233762"
            d="M170.12 31.01l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-4"
            d="M192.41 29.79L169.86 35v-4.25l22.55-5.18zm-22 4.46l21.52-5v-2.91l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-4">
          <path
            data-name="Rectangle 189-4"
            fill="#233762"
            d="M170.12 34.62l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-4"
            d="M192.41 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.52-5v-3l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-4">
          <path
            data-name="Rectangle 190-4"
            fill="#233762"
            d="M170.12 38.23l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-4"
            d="M192.41 36.92l-22.55 5.32V38l22.55-5.27zm-22 4.54l21.52-5.07v-2.92l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-4">
          <path
            data-name="Rectangle 191-4"
            fill="#233762"
            d="M170.12 41.85l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-4"
            d="M192.41 40.48l-22.55 5.37v-4.27l22.55-5.3zm-22 4.59L191.9 40v-3l-21.52 5.07z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-4">
          <path
            data-name="Rectangle 192-4"
            fill="#233762"
            d="M170.12 45.48l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-4"
            d="M192.41 44.07l-22.55 5.42v-4.27l22.55-5.36zm-22 4.64l21.52-5.17v-2.92l-21.52 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-4">
          <path
            data-name="Rectangle 193-4"
            fill="#233762"
            d="M170.12 49.1l22.04-5.29v3.57l-22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-4"
            d="M192.41 47.64l-22.55 5.46v-4.27l22.55-5.41zm-22 4.68l21.52-5.21v-2.92l-21.52 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-4"
          fill="#fff"
          d="M180.58 10.63l1.44-.32v39.52l-1.44.35V10.63z"
        />
      </g>
      <path fill="#233762" d="M39.52 3.36h1.26v45.35h-1.26z" />
      <g data-name="Group 85-5">
        <g data-name="Group 498-5">
          <path
            data-name="Rectangle 182-5"
            fill="#233762"
            d="M133.59 8.25l-27.78-6.02v49.49l27.78 6.8V8.25z"
          />
          <path
            data-name="Path 2338-5"
            d="M105.32 1.51l28.77 6.23v51.54l-28.77-7.06zm27.76 7.28L106.29 3v48.2l26.79 6.56z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-5">
          <path
            data-name="Rectangle 183-5"
            fill="#233762"
            d="M130.59 12.91l-22.04-4.84v3.56l22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-5"
            d="M108.3 7.7l22.54 5V17l-22.54-5zm22 5.49l-21.5-4.73v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-5">
          <path
            data-name="Rectangle 184-5"
            fill="#233762"
            d="M130.59 16.52l-22.04-4.89v3.57l22.04 4.94v-3.62z"
          />
          <path
            data-name="Path 2340-5"
            d="M108.3 11.26l22.54 5v4.27l-22.54-5zm22 5.54L108.8 12v2.92l21.52 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-5">
          <path
            data-name="Rectangle 185-5"
            fill="#233762"
            d="M130.59 20.14l-22.04-4.94v3.57l22.04 4.98v-3.61z"
          />
          <path
            data-name="Path 2341-5"
            d="M108.3 14.83l22.54 5v4.26L108.3 19zm22 5.58l-21.5-4.82v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-5">
          <path
            data-name="Rectangle 186-5"
            fill="#233762"
            d="M130.59 23.77l-22.04-4.97v3.56l22.04 5.03v-3.62z"
          />
          <path
            data-name="Path 2342-5"
            d="M108.3 18.43l22.54 5.09v4.26l-22.54-5.14zm22 5.62l-21.5-4.86v2.92L130.32 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-5">
          <path
            data-name="Rectangle 187-5"
            fill="#233762"
            d="M130.59 27.39l-22.04-5.03v3.57L130.59 31v-3.61z"
          />
          <path
            data-name="Path 2343-5"
            d="M108.3 22l22.54 5.14v4.26l-22.54-5.2zm22 5.67l-21.5-4.92v2.92l21.52 4.95z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-5">
          <path
            data-name="Rectangle 188-5"
            fill="#233762"
            d="M130.59 31l-22.04-5.07v3.57l22.04 5.11V31z"
          />
          <path
            data-name="Path 2344-5"
            d="M108.3 25.56l22.54 5.18V35l-22.54-5.23zm22 5.71l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-5">
          <path
            data-name="Rectangle 189-5"
            fill="#233762"
            d="M130.59 34.61l-22.04-5.11v3.56l22.04 5.16v-3.61z"
          />
          <path
            data-name="Path 2345-5"
            d="M108.3 29.13l22.54 5.22v4.27l-22.54-5.28zm22 5.76l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-5">
          <path
            data-name="Rectangle 190-5"
            fill="#233762"
            d="M130.59 38.22l-22.04-5.16v3.57l22.04 5.2v-3.61z"
          />
          <path
            data-name="Path 2346-5"
            d="M108.3 32.69L130.84 38v4.26l-22.54-5.35zm22 5.81l-21.52-5v2.92l21.52 5.06z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-5">
          <path
            data-name="Rectangle 191-5"
            fill="#233762"
            d="M130.59 41.83l-22.04-5.2v3.57l22.04 5.24v-3.61z"
          />
          <path
            data-name="Path 2347-5"
            d="M108.3 36.26l22.54 5.31v4.26l-22.54-5.37zm22 5.84L108.8 37v2.91L130.32 45z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-5">
          <path
            data-name="Rectangle 192-5"
            fill="#233762"
            d="M130.59 45.47l-22.04-5.24v3.56l22.04 5.29v-3.61z"
          />
          <path
            data-name="Path 2348-5"
            d="M108.3 39.84l22.54 5.36v4.27l-22.54-5.41zm22 5.89l-21.5-5.12v2.92l21.52 5.16z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-5">
          <path
            data-name="Rectangle 193-5"
            fill="#233762"
            d="M130.59 49.08l-22.04-5.29v3.57l22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-5"
            d="M108.3 43.41l22.54 5.41v4.26l-22.54-5.46zm22 5.94l-21.5-5.17v2.92l21.52 5.2z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-5"
          fill="#fff"
          d="M120.13 10.61l-1.44-.31v39.51l1.44.35V10.61z"
        />
      </g>
      <g data-name="Group 85-6">
        <g data-name="Group 498-6">
          <path
            data-name="Rectangle 182-6"
            fill="#233762"
            d="M133.59 8.25l27.78-6.02v49.49l-27.78 6.8V8.25z"
          />
          <path
            data-name="Path 2338-6"
            d="M161.86 52.22l-28.78 7.06V7.74l28.78-6.23zm-27.77 5.55l26.8-6.56V3l-26.8 5.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-6">
          <path
            data-name="Rectangle 183-6"
            fill="#233762"
            d="M136.59 12.91l22.04-4.84v3.56l-22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-6"
            d="M158.88 11.91l-22.55 5v-4.26l22.56-4.95zm-22 4.24l21.53-4.77V8.46l-21.53 4.73z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-6">
          <path
            data-name="Rectangle 184-6"
            fill="#233762"
            d="M136.59 16.52l22.04-4.89v3.57l-22.04 4.94v-3.62z"
          />
          <path
            data-name="Path 2340-6"
            d="M158.88 15.48l-22.55 5v-4.22l22.56-5zm-22 4.28l21.53-4.82V12l-21.53 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-6">
          <path
            data-name="Rectangle 185-6"
            fill="#233762"
            d="M136.59 20.14l22.04-4.94v3.57l-22.04 4.98v-3.61z"
          />
          <path
            data-name="Path 2341-6"
            d="M158.88 19l-22.55 5.1v-4.22l22.56-5zm-22 4.32l21.53-4.86v-2.87l-21.56 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-6">
          <path
            data-name="Rectangle 186-6"
            fill="#233762"
            d="M136.59 23.77l22.04-4.97v3.56l-22.04 5.03v-3.62z"
          />
          <path
            data-name="Path 2342-6"
            d="M158.88 22.64l-22.55 5.14v-4.26l22.56-5.09zm-22 4.37l21.53-4.9v-2.92L136.85 24z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-6">
          <path
            data-name="Rectangle 187-6"
            fill="#233762"
            d="M136.59 27.39l22.04-5.03v3.57L136.59 31v-3.61z"
          />
          <path
            data-name="Path 2343-6"
            d="M158.88 26.2l-22.55 5.19v-4.26L158.89 22zm-22 4.42l21.53-4.95v-2.92l-21.53 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-6">
          <path
            data-name="Rectangle 188-6"
            fill="#233762"
            d="M136.59 31l22.04-5.07v3.57l-22.04 5.11V31z"
          />
          <path
            data-name="Path 2344-6"
            d="M158.88 29.77L136.33 35v-4.26l22.56-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-6">
          <path
            data-name="Rectangle 189-6"
            fill="#233762"
            d="M136.59 34.61l22.04-5.11v3.56l-22.04 5.16v-3.61z"
          />
          <path
            data-name="Path 2345-6"
            d="M158.88 33.34l-22.55 5.28v-4.27l22.56-5.22zm-22 4.5l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-6">
          <path
            data-name="Rectangle 190-6"
            fill="#233762"
            d="M136.59 38.22l22.04-5.16v3.57l-22.04 5.2v-3.61z"
          />
          <path
            data-name="Path 2346-6"
            d="M158.88 36.91l-22.55 5.31V38l22.56-5.27zm-22 4.53l21.53-5.06v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-6">
          <path
            data-name="Rectangle 191-6"
            fill="#233762"
            d="M136.59 41.83l22.04-5.2v3.57l-22.04 5.24v-3.61z"
          />
          <path
            data-name="Path 2347-6"
            d="M158.88 40.46l-22.55 5.37v-4.26l22.56-5.31zm-22 4.59l21.53-5.11V37l-21.56 5.1z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-6">
          <path
            data-name="Rectangle 192-6"
            fill="#233762"
            d="M136.59 45.47l22.04-5.24v3.56l-22.04 5.29v-3.61z"
          />
          <path
            data-name="Path 2348-6"
            d="M158.88 44.06l-22.55 5.41V45.2l22.56-5.36zm-22 4.63l21.53-5.16v-2.92l-21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-6">
          <path
            data-name="Rectangle 193-6"
            fill="#233762"
            d="M136.59 49.08l22.04-5.29v3.57l-22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-6"
            d="M158.88 47.62l-22.55 5.46v-4.26l22.56-5.41zm-22 4.68l21.53-5.2v-2.92l-21.53 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-6"
          fill="#fff"
          d="M147.05 10.61l1.44-.31v39.51l-1.44.35V10.61z"
        />
      </g>
      <path fill="#233762" d="M161.81 3.34h1.26v45.35h-1.26z" />
    </svg>
  );
};
